import type { TConversationsFilter } from 'src/services/api/messages/use-conversations-search';

export const API_INBOXES_PATH = 'api/landlord/conversations/inboxes';
/**
 * DEPRECATED: This constant is no longer used. Use API_INBOXES_PATH instead.
 */
export const API_INBOX_FAVORITES_PATH = 'api/landlord/conversations/inboxes/favorites';

export const INITIAL_FILTERS: TConversationsFilter = Object.freeze({});

export const isFiltersEmpty = (filters: TConversationsFilter): boolean => {
    return Object.keys(filters).length === 0;
};
